import { render, staticRenderFns } from "./SuperLogin.vue?vue&type=template&id=31b1c700&"
import script from "./SuperLogin.vue?vue&type=script&lang=js&"
export * from "./SuperLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports